import { ExclamationMarkIcon } from "@/components/Icons/ExclamationMarkIcon";
import { useHandleError } from "@/hooks/useHandleError";
import { useUpdateWebUser } from "@roman/shared/hooks/auth/useUpdateWebUser";
import { useInappropriateWordsCheck } from "@roman/shared/hooks/useInappropriateWords";
import { getAuthenticatedUser, useAuthStore } from "@roman/shared/store/auth.store";
import type React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EditProfileButton } from "./Button";

export const EditProfileOnMypage = () => {
  const navigate = useNavigate();
  const user = getAuthenticatedUser();
  const fetchUser = useAuthStore((state) => state.fetchAndSetUser);
  const [username, setUsername] = useState<string>();
  const [isLengthError, setIsLengthError] = useState<boolean>(false);

  const { updateWebUser } = useUpdateWebUser(useHandleError);

  const {
    isInappropriate: isInappropriateError,
    checkText: checkInappropriateWords,
    resetCheck: resetInappropriateCheck,
  } = useInappropriateWordsCheck();

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.currentTarget.value);
    resetInappropriateCheck();
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!username || isLengthError) return;
    const { isInappropriate } = checkInappropriateWords(username);
    if (isInappropriate) {
      return;
    }

    await updateWebUser(
      { name: username },
      {
        onSuccess: async () => {
          await fetchUser();
          navigate("/");
        },
      },
    );
  };

  useEffect(() => {
    if (username) setIsLengthError(username?.length > 15);
  }, [username]);

  useEffect(() => {
    if (user) setUsername(user.name);
  }, [user]);

  return (
    <div
      className="flex flex-col items-center min-h-[calc(100vh-72px)]"
      style={{
        backgroundImage: `url('/assets/bg.svg')`,
        backgroundRepeat: "repeat",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div className="w-full min-h-[calc(100vh-72px)] max-w-3xl p-8 bg-white">
        <div className="flex flex-col items-start gap-10 w-full">
          <div className="">
            <p className="font-semibold text-xl -tracking-[.01em] text-black">プロフィール編集</p>
          </div>

          <form onSubmit={onSubmit} className="flex flex-col items-center w-full gap-10">
            {/* <div className="flex items-center gap-2">
              <Icon src="/assets/profile-edit-icon.svg" imageSize={{ height: "80", width: "80" }} />
              <label className="w-[221px] flex items-center justify-center border border-solid border-primary text-base font-semibold rounded-3xl py-2.5 px-5 text-primary cursor-pointer">
                写真を登録/変更
                <input
                  type="file"
                  hidden
                />
              </label>
            </div> */}

            <div className="flex flex-col items-center w-full">
              <label className="sm:w-[500px] w-full mx-8">
                <p className="font-medium text-base text-dark-gray mb-2">ユーザー名</p>
                <input
                  type="text"
                  name="name"
                  value={username}
                  className="border border-solid border-disabled px-5 py-2.5 font-normal text-base rounded-md w-full mb-1"
                  placeholder="（例）山田太郎"
                  onChange={handleUsernameChange}
                />
                <p className="font-medium text-base text-gray">※15文字以内</p>
              </label>
              {isLengthError && (
                <div className="sm:w-[500px] flex items-start w-full gap-1 mt-1">
                  <ExclamationMarkIcon />
                  <p className="text-sm text-red">15文字を超えてます。</p>
                </div>
              )}
              {isInappropriateError && (
                <div className="sm:w-[500px] flex items-start w-full gap-1 mt-1">
                  <ExclamationMarkIcon />
                  <p className="text-sm text-red">その言葉は不適切なため、使用できません。</p>
                </div>
              )}
            </div>

            <EditProfileButton className="sm:w-[500px] mx-8">保存する</EditProfileButton>
          </form>
        </div>
      </div>
    </div>
  );
};
